<template>
  <Fragment>
    <div class="form-group form-row">
      <StepFieldLabel column-classes="col-5"> Tire Style </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-sm-3 col-md-2">
        <select
          id="exampleFormControlSelect1"
          v-model="form.tireStyle"
          class="form-control custom-select"
          @change="onFieldChange(form.tireStyle, tires.tireStyle)"
        >
          <option value="Dual">Dual</option>
          <option value="Super Single">Super Single</option>
        </select>
      </StepInputGroup>
    </div>

    <div class="form-group form-row align-items-center">
      <StepFieldLabel column-classes="col-5">
        Cost of Tire<br /><span>USD</span>
      </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-sm-3 col-md-2">
        <Money
          v-model="form.costOfTire"
          class="form-control form-control-lg"
          type="text"
          v-bind="masks.moneyNoPrecision"
          required
          @input="onFieldChange($event, tires.costOfTire)"
        />
      </StepInputGroup>
      <HelpIcon>
        This will vary significantly based on the tire brand, size, and style
        (Dual or Super Single)
      </HelpIcon>
    </div>

    <div class="form-group form-row align-items-center">
      <StepFieldLabel column-classes="col-5">
        Tire Life<br /><span>miles</span>
      </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-sm-3 col-md-2">
        <Money
          v-model="form.tireLife"
          class="form-control form-control-lg"
          v-bind="masks.number"
          type="text"
          required
          @input="onFieldChange($event, tires.tireLife)"
        />
      </StepInputGroup>
    </div>
  </Fragment>
</template>

<script>
import { Money } from 'v-money';
import { Fragment } from 'vue-frag';

import HelpIcon from '../step-elements/HelpIcon.vue';
import StepFieldLabel from '../step-elements/StepFieldLabel.vue';
import StepInputGroup from '../step-elements/StepInputGroup.vue';
import { mapState, mutation, masks } from '../store';
import { defaultTires } from '../store/state';

export default {
  name: 'Tires',

  components: { Money, Fragment, HelpIcon, StepInputGroup, StepFieldLabel },

  data() {
    return {
      /** @type {Tires} */
      form: defaultTires('Dual'),
      masks,
    };
  },

  computed: {
    ...mapState({
      /** @returns {Tires} */
      tires: (/** @type {ROICalculatorState} */ state) => {
        return state.formValues.tires;
      },
    }),
  },

  watch: {
    tires: {
      handler: function (newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }

        this.form = JSON.parse(JSON.stringify(newVal));
      },
      immediate: true,
    },
  },

  methods: {
    onFieldChange(formValue, stateValue) {
      if (stateValue == formValue) {
        return;
      }

      this.$store.commit(mutation('SET_TIRES_VALUES'), this.form);
    },
  },
};

/**
 * @typedef {import('../store/state').ROICalculatorState} ROICalculatorState
 * @typedef {import('../store/state').Tires} Tires
 */
</script>
